export default __webpack_public_path__ + "static/media/No1Closed.6e059fb7.jpg";